import React from "react";
import Input from "./Input";
import Select from "./Select";
import Radio from "./Radio";
import Checkbox from "./Checkbox";
import DatePicker from "./DatePicker";
import ImageOrVideoUploadSingle from "./ImageOrVideoUpload";
import FileUploadandDownload from "./FileUploadandDownload";

const DynamicField = ({
  type,
  label,
  name,
  value,
  id,
  className,
  placeholder,
  required,
  readonly,
  disabled,
  maxlength,
  minlength,
  autocomplete,
  autofocus,
  form,
  title,
  max,
  min,
  step,
  errorText,
  errorType,
  dropdownData = [],
  onChange = () => {},
  uploadButtonText,
  uploadFile,
}) => {
  const updatedDropdownData = dropdownData?.map((item) => ({
    ...item,
    name: item.label,
  }));
  const handleInputChange = (e) => {
    onChange({
      target: {
        name,
        value: e.target.value,
      },
    });
  };

  const handleSelectChange = (val) => {
    onChange({
      target: {
        name,
        value: val,
      },
    });
  };

  const handleFileChange = (file) => {
    onChange({
      target: {
        name,
        value: file,
      },
    });
  };
  const handleCheckboxChange = (e) => {
    onChange({
      target: {
        name,
        value: e.target.checked,
      },
    });
  };
  const handleDateChange = (newDate) => {
    const startDate = newDate.startDate || "";
    onChange({
      target: {
        name,
        value: startDate,
      },
    });
  };
  const downloadButtonClick = async (file) => {
    const url = file?.url;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const contentType = blob.type;
      console.log("Content-Type:", contentType);
      
      let extension = ".bin"; 
      if (contentType === "application/pdf") {
        extension = ".pdf";
      } else if (contentType === "image/png") {
        extension = ".png";
      } else if (contentType === "image/jpeg") {
        extension = ".jpg";
      }

      const baseName = file?.name?.split(".")[0] || "downloaded-file";

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = baseName + extension;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <>
      {(type === "input" || type === "email") && (
        <Input
          isDisabled={disabled}
          inputName={name}
          value={value}
          label={label}
          inputPlaceholder={placeholder}
          errorText={errorText}
          errorType={errorType}
          required={required}
          onChange={handleInputChange}
        />
      )}

      {type === "select" && (
        <Select
          placeholder={placeholder}
          dropdownData={updatedDropdownData}
          setSelectedValue={handleSelectChange}
          selectedValue={value}
          label={label}
          errorText={errorText}
          errorType={errorType}
          required={required}
        />
      )}
      {type === "datepicker" && (
        <DatePicker
          className={"placeholder:text-[10px]"}
          label={label}
          placeholder={placeholder}
          range={false}
          value={
            value
              ? {
                  startDate: new Date(value),
                  endDate: new Date(value),
                }
              : {
                  startDate: null,
                  endDate: null,
                }
          }
          errorText={errorText}
          errorType={errorType}
          required={required}
          onChange={handleDateChange}
        />
      )}
      {type === "video" && (
        <div className="relative col-span-12">
          <ImageOrVideoUploadSingle
            size="small"
            label={label || "Upload File"}
            labelClasses={"!mb-2"}
            placeholder={placeholder}
            value={value}
            onChange={handleFileChange}
            placeholderClass="text-white"
            containerClasses={
              value
                ? "max-w-96"
                : "!bg-chestnut-rose !w-auto !inline-flex !pr-3 !text-white !border-transparent !rounded-full"
            }
            errorText={errorText}
            errorType={errorType}
            required={required}
            accept=".mp4,.webm,.png,image/*,video/*"
          />
        </div>
      )}
      {type === "radio" && (
        <div className="mb-4">
          {label && (
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {label}
              {required && <span className="text-red-500">*</span>}
            </label>
          )}
          <div className="flex flex-wrap gap-4">
            {dropdownData?.map((option) => (
              <Radio
                key={option._id}
                id={`${id}-${option.value}`}
                radioName={name}
                value={option.value}
                isChecked={value === option.value}
                onChange={() =>
                  onChange({
                    target: {
                      name,
                      value: option.value,
                    },
                  })
                }
                radioLabel={option.label}
                errorText={errorText}
                errorType={errorType}
                required={required}
              />
            ))}
          </div>
          {errorType && errorType === "error" && (
            <div className="text-xs text-red-600 mt-1">
              <i className="fa-regular fa-fw fa-square-exclamation text-sm mr-1"></i>
              {errorText}
            </div>
          )}
          {errorType && errorType === "warning" && (
            <div className="text-xs text-amber-600 mt-1">
              <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
              {errorText}
            </div>
          )}
          {errorType && errorType === "success" && (
            <div className="text-xs text-green-600 mt-1">
              <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
              {errorText}
            </div>
          )}
          {errorType && errorType === "info" && (
            <div className="text-xs text-sky-600 mt-1">
              <i className="fa-regular fa-fw fa-circle-info text-sm mr-1"></i>
              {errorText}
            </div>
          )}
        </div>
      )}
      {type === "file" && (
        <div className="relative col-span-4">
          <FileUploadandDownload
            size="small"
            label={label || "Upload File"}
            labelClasses={"!mb-2"}
            placeholder={placeholder}
            value={value}
            onChange={handleFileChange}
            placeholderClass="text-white"
            containerClasses={
              value
                ? "max-w-96"
                : "!bg-chestnut-rose !w-auto !inline-flex !pr-3 !text-white !border-transparent !rounded-full"
            }
            errorText={errorText}
            errorType={errorType}
            required={required}
            uploadSize={7}
            iconStyleClass={"right-[26px] md:right-auto"}
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docs,.webp"
            uploadFile={uploadFile}
            uploadButtonText={uploadButtonText}
            downloadButtonClick={downloadButtonClick}
          />
        </div>
      )}
      {type === "checkbox" && (
        <div className="mb-4 mt-4">
          <Checkbox
            checkboxLabel={label}
            checkboxLableClass={"!text-sm"}
            checkboxName={name}
            checked={value}
            onChange={handleCheckboxChange}
            errorText={"required"}
            errorType={errorType}
            required={required}
            checkboxInputClass="!top-1/2 !transform !translate-y-[-50%]"
          />
        </div>
      )}
    </>
  );
};

export default DynamicField;
